import classNames from "classnames"
import React from "react"

const Bar = props => {
    const barClassNames = classNames("layout-rt__bar", {
        "layout-rt__bar--bold": props.bold,
    })

    return (
        <div className={barClassNames} data-testid="bar">
            {props.children}
        </div>
    )
}

export default Bar
